module.exports = __webpack_public_path__ + "static/image/service/pc/gift@3x.jpg?bfa08e4e";